import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IEmployment,
  IEmploymentListRequest,
  EmploymentState,
} from "@/types/employment";
import CustomRequest from "../customRequest";

const actions: ActionTree<EmploymentState, RootState> = {
  async get({ commit }, id: number) {
    await CustomRequest.get<IPagination<IEmployment>>({
      uri: `/employmeny/${id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: IEmploymentListRequest) {
    await CustomRequest.get<IPagination<IEmployment>>({
      uri: "/employment",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
